module.exports = __webpack_public_path__ + "img/388d415.png";